import React from 'react';
import {FormattedMessage} from 'react-intl';
import ProvenExpertRating from '../../../static/json/ProvenExpertRating.json';
import {ProvenExpertStarRating} from './ProvenExpertStarRating';
import {ProvenExpertStar} from '../dato/block/provenExpert/ProvenExpertStar';

export const ProvenExpertWidget = () => {
  const stopColor = '#ccc',
    color = '#C8B274',
    width = '16',
    height = '16';

  return (
    <div data-testid='proven-expert-widget' className='sm:flex sm:flex-row sm:justify-start sm:items-center mt-3 md:mt-1'>
      <div className='hidden md:block'>
        <ProvenExpertStarRating stopColor={stopColor} color={color} width={width} height={height} />
      </div>
      <div className='flex justify-start items-center md:hidden'>
        <span className='text-white mr-1'>{ProvenExpertRating.ratingValue.toFixed(2)}</span>
        <ProvenExpertStar stopColor={stopColor} height={height} width={width} color={color} fill={1} />
        <div className='ml-1'>
          <ProvenExpertLink />
        </div>
      </div>
      <div className='hidden md:block'>
        <ProvenExpertLink />
      </div>
    </div>
  );
};

const ProvenExpertLink = () => (
  <a
    className='underline underline-offset-1 text-sm text-center inline-block sm:w-auto mb-1 sm:text-left sm:text-xss sm:ml-1 text-[#C8B274]'
    href='https://www.provenexpert.com/de-de/ready2order-gmbh/'
    target='_blank'
  >
    <FormattedMessage id='provenExpert.widget.link' values={{reviews: ProvenExpertRating.reviewCount}} />
  </a>
);
